module.exports = __webpack_public_path__ + "img/LeanRevisions-hLogo.a565687f.png";